export default __webpack_public_path__ + "static/sentinel-banner-at-finger-tips-a0477bb7636acef728d35fb614e8da6b.jpg";